import React from 'react'
import createIcon from '@/lib/create-icon'

export const PlusCircleSVGIcon = createIcon(
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3050_12501)">
      <path d="M7.99967 5.33331V10.6666M5.33301 7.99998H10.6663M14.6663 7.99998C14.6663 11.6819 11.6816 14.6666 7.99967 14.6666C4.31778 14.6666 1.33301 11.6819 1.33301 7.99998C1.33301 4.31808 4.31778 1.33331 7.99967 1.33331C11.6816 1.33331 14.6663 4.31808 14.6663 7.99998Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_3050_12501">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>,
)
